import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <footer class="footer grid grid-cols-1 lg:grid-cols-2 p-10 text-neutral-content">
        <div>
          <p className="text-white">All Rights Reserved || AL NEED ROY SUVRA</p>
        </div>
        <div>
          <span class="footer-title text-white font-serif text-3xl">My Social</span>
          <div class="grid grid-flow-col gap-4">
            <a href="https://www.linkedin.com/in/al-need-roy-suvra-823a07228/">
              <svg
                width="50"
                height="50"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                class="fill-current"
              >
                <FaLinkedin />
              </svg>
            </a>
            <a href="https://github.com/alneedrs2">
              <svg
                width="50"
                height="50"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                class="fill-current"
              >
                <FaGithub />
              </svg>
            </a>
            <a href="https://www.facebook.com/alneedroy.me/">
              <svg
                width="50"
                height="50"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                class="fill-current"
              >
              <FaFacebook/>
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
